import type { track as TrackFunction } from "pro-features/components/WithTrack/src/context";

const createAIAgentKBTrackingService = (track: TrackFunction) => {
    const trackKBEvent = (action: string, eventName: string): void => {
        track("Agents settings", action, eventName);
    };

    const trackOpenModal = () => {
        trackKBEvent("click", "Open modal");
    };

    const trackSaveChanges = (otherNotes: string | undefined, numbersOfFiles = 0) => {
        trackKBEvent("click", `Save changes/${otherNotes}/${numbersOfFiles}`);
    };

    const trackCancel = () => {
        trackKBEvent("click", "Cancel");
    };

    const trackProductOfferingAdd = (productOffering: string, companyName?: string) => {
        trackKBEvent("click", `add offering/${productOffering}/${companyName ?? ""}`);
    };

    const trackProductOfferingRemove = () => {
        trackKBEvent("click", "delete offering");
    };

    const trackPersonaAdd = (persona: string) => {
        trackKBEvent("click", `add custom persona/${persona}`);
    };

    const trackPersonaRemove = () => {
        trackKBEvent("click", "delete persona");
    };

    const trackTargetCompanyAdd = (company: string) => {
        trackKBEvent("click", `add custom target company/${company}`);
    };

    const trackTargetCompanyRemove = () => {
        trackKBEvent("click", "delete target company");
    };

    const trackCountrySelect = (country: string) => {
        trackKBEvent("click", `select country/${country}`);
    };

    const trackLanguageSelect = (language: string) => {
        trackKBEvent("click", `select language/${language}`);
    };

    const trackRoleSelect = (role: string) => {
        trackKBEvent("click", `select role/${role}`);
    };

    const trackFileRemove = () => {
        trackKBEvent("click", "remove file");
    };

    const trackFileUpload = (fileName: string, status: "success" | "failure") => {
        trackKBEvent("click", `upload file/${status}/${fileName}`);
    };

    const trackPOExtracted = (value: string[]) => {
        trackKBEvent("click", `product offering suggested/${value.length}/${value.join(",")}`);
    };

    return {
        trackOpenModal,
        trackSaveChanges,
        trackCancel,
        trackProductOfferingAdd,
        trackProductOfferingRemove,
        trackPersonaAdd,
        trackPersonaRemove,
        trackTargetCompanyAdd,
        trackTargetCompanyRemove,
        trackCountrySelect,
        trackLanguageSelect,
        trackRoleSelect,
        trackFileRemove,
        trackFileUpload,
        trackPOExtracted,
    };
};

export default createAIAgentKBTrackingService;
